// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".svg-icon[data-v-c8a70580] {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  line-height: 1;\n  width: 1em;\n  height: 1em;\n}\n.svg-icon[data-v-c8a70580] svg {\n  width: 100%;\n  height: 100%;\n  font-size: var(--font-size);\n}\n", ""]);
// Exports
module.exports = exports;
